module.exports = __webpack_public_path__ + "bundle/fonts/Roboto-Medium.ttf";